export default "__VITE_ASSET__BLMhujgF__"